import moment from '@gid/vue-common/app-settings/moment';
import Vue from 'vue';
import Clipboard from 'v-clipboard';
import VueI18n from 'vue-i18n';
import VueMoment from 'vue-moment';
import * as Sentry from '@sentry/browser';
import VueTagManager from 'vue-tag-manager';

import App from './App.vue';

import messages from './i18n/messages';
import router, { initRouter, applyRouteTitle } from './router';
import store from './store';
import {
  initVeeValidateRulesWithI18n,
  setVeeValidateLocale,
} from './app/components';
import './app/filters';

import ChatContextPlugin from '@gid/vue-common/plugins/chat-context.plugin';

import {
  PURGE_AUTH,
  STORE_USER_DATA,
  STORE_ACCESS_TOKEN,
} from '@gid/vue-common/store/auth.module/types';
import { e2e } from '@gid/vue-common/app-settings/customDirectives';
import { setupGoogleAnalytics } from '@gid/vue-common/app-settings/googleAnalytics';
import '@gid/vue-common/app-settings/registerServiceWorker';
import { getEnv } from '@gid/vue-common/utils';

import '@/assets/scss/styles.scss';
import '@/assets/scss/onboarding.scss';

Vue.use(Clipboard);
Vue.use(VueI18n);
Vue.use(VueMoment, { moment });
Vue.use(ChatContextPlugin, { store });
Vue.directive('e2e', e2e);

// Set app identifier for template-based context injection
Vue.prototype.$appId = 'partner';

const defaultLocale = store.getters.locale;
const i18n = new VueI18n({
  locale: defaultLocale,
  fallbackLocale: 'en',
  silentFallbackWarn: true,
  messages,
});
moment.locale(defaultLocale);
setVeeValidateLocale(defaultLocale);
initVeeValidateRulesWithI18n(i18n);

initRouter(router, i18n, store);

store.subscribe(({ type }) => {
  if (type === PURGE_AUTH && router.currentRoute.name != 'login') {
    // Go to login page on logout
    router.push({ name: 'login' });
  } else if (type === STORE_USER_DATA) {
    // Set locales in used components
    const locale = store.getters.locale;
    i18n.locale = locale;
    moment.locale(locale);
    setVeeValidateLocale(locale);
    // Re-resolve the current route's document.title in the new locale —
    // beforeEach already ran in the boot locale and won't fire again.
    applyRouteTitle(router.currentRoute, i18n, store);
  } else if (type === STORE_ACCESS_TOKEN) {
    initRouter(router, i18n, store);
  }
});

setupGoogleAnalytics(router);

Vue.use(VueTagManager, {
  gtmId: 'GTM-T9G49SB',
});

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');

if (getEnv('NODE_ENV') == 'production') {
  Sentry.init({
    dsn: 'https://3d4312b908af40b586cd9b4ec08372da@sentry.io/1419766',
    environment: getEnv('GID_ENV') ?? getEnv('VUE_APP_ENV'),
    release: getEnv('VUE_APP_SOURCE_VERSION'),
    integrations: [new Sentry.Integrations.Vue({ Vue })],
  });
}
